import { render, staticRenderFns } from "./TypeTooltip.vue?vue&type=template&id=da64f07e&lang=pug&"
import script from "./TypeTooltip.vue?vue&type=script&lang=ts&"
export * from "./TypeTooltip.vue?vue&type=script&lang=ts&"
import style0 from "./TypeTooltip.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports